import React, { ReactElement, ReactNode } from 'react';
import { UserPermissionName } from '../models/user-permission-name';
import { useAuthorize } from '../hooks/use-authorize';
import { FormatAlignJustify, Margin } from '@mui/icons-material';
import { PermissionErrorComponent } from './permission-error.component';

interface GuardedRouteProps {
  children: ReactNode;
  requiredPermissions: UserPermissionName[];
  showPermissionError?: ReactNode;
}



export const GuardedComponent = ({
  children,
  showPermissionError,
  requiredPermissions,
}: GuardedRouteProps): ReactElement | null => {
  const isAuthorized = useAuthorize(requiredPermissions);

  if (requiredPermissions.length > 0) {
    // console.log(requiredPermissions);
  }
  if (isAuthorized) {
    return <>{children}</>;
  }
  return showPermissionError ? <PermissionErrorComponent /> : null;
};
